// extracted by mini-css-extract-plugin
export var progressBar = "_ka-0";
export var progressBarInner = "_ka-1";